import { IconButton } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import * as React from 'react';
import { passwordPattern, passwordPatternErrorMessage } from '../../core/constants';
import Input from './Input';

const PasswordField = ({
	label = 'Password',
	name = 'password',
	startAdornment,
	showPassword,
	onTogglePasswordMask,
	required = true,
	validate = true,
	customValidate
}: Props) => {
	return (
		<Input
			type={showPassword ? 'text' : 'password'}
			label={label}
			name={name}
			required={required}
			validate={customValidate}
			pattern={validate ? passwordPattern : null}
			patternErrorMessage={validate ? passwordPatternErrorMessage : null}
			startAdornment={startAdornment}
			endAdornment={
				<IconButton
					aria-label="toggle password visibility"
					onClick={onTogglePasswordMask}
					onMouseDown={(e) => e.preventDefault()}
					edge="end"
					size="large"
				>
					{showPassword ? <Visibility /> : <VisibilityOff />}
				</IconButton>
			}
		/>
	);
};

interface Props {
	startAdornment?: React.ReactNode;
	label?: string;
	name?: string;
	showPassword: boolean;
	onTogglePasswordMask: () => void;
	required?: boolean;
	validate?: boolean;
	customValidate?: unknown;
}

export default PasswordField;
